'use client';

import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      richColors
      closeButton
      dir="rtl"
      toastOptions={{
        style: {
          fontFamily: 'var(--font-dana)',
        },
      }}
    />
  );
}







